// src/redux/slices/userSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { getWishlistItems, getCartItems, getHomeData } from "./userActions";

const userSlice = createSlice({
  name: "user",
  initialState: {
    wishlist: [],
    homeData: [],
    cart: [],
    loading: false,
    homeLoading: false,
    error: null,
  },
  reducers: {
    resetUserData: (state) => {
      state.wishlist = [];
      state.cart = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Wishlist handlers
      .addCase(getWishlistItems.pending, (state) => {
        if ((state.wishlist?.products?.length ?? 0) === 0) {
          state.loading = true;
        }
      })
      .addCase(getWishlistItems.fulfilled, (state, action) => {
        state.wishlist = action.payload.wishlist;
        state.loading = false;
      })
      .addCase(getWishlistItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCartItems.pending, (state) => {
        if ((state.cart?.products?.length ?? 0) === 0) {
          state.loading = true;
        }
      })
      .addCase(getCartItems.fulfilled, (state, action) => {
        state.cart = action.payload.cart;
        state.loading = false;
      })
      .addCase(getCartItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getHomeData.pending, (state, action) => {
        if ((state.products?.length ?? 0) === 0) {
          state.homeLoading = true;
        }
      })
      .addCase(getHomeData.fulfilled, (state, action) => {
        const { cartItems, wishlistItems, ...rest } = action.payload;
        state.cart = cartItems;
        state.wishlist = wishlistItems;
        state.homeData = rest;
        state.homeLoading = false;
      });
  },
});

export const { resetUserData } = userSlice.actions;
export default userSlice.reducer;
